"use client"

import styled from "@emotion/styled"
import { APIProvider, AdvancedMarker, Map, Pin, useMapsLibrary } from "@vis.gl/react-google-maps"
import { useEffect, useState } from "react"

const APIKEY = "AIzaSyD2AanBqJJ8WM8JL6LJ3jjbYkUgD4Mk0Cc"
const MAPID = "40df340c1a7a4582"
// const position = { lat: 32.109333, lng: 34.855499 }

const StyledMapContainer = styled.div<{ locale: string; newStyle?: boolean }>`
  width: 100%;
  height: ${({ newStyle }) => (newStyle ? "225px" : "328px")};
  border-radius: 16px;
  overflow: hidden;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: ${({ newStyle }) => (newStyle ? "193px" : "100%")};
  }
  .gmnoprint {
    z-index: 99999999;
    right: ${(p) => (p.locale === "he" ? "0px !important" : "unset !important")};
    left: ${(p) => (p.locale === "en" ? "0px !important" : "unset !important")};

    > div {
      border-radius: 8px !important;
    }
    img {
      width: 12px !important;
      height: 12px !important;
    }
    button {
      border-radius: 8px !important;
    }
  }
`

type Props = {
  address?: { latitude: number; longitude: number }
  addressStr?: string
  locale: string
  newStyle?: boolean
}

const MapContainer = ({ locale, address, newStyle, addressStr }: Props) => {
  const core = useMapsLibrary("core")
  const [position, setPosition] = useState<{ lat: number; lng: number } | null>(null)

  useEffect(() => {
    if (address?.latitude && address?.longitude) {
      setPosition({ lat: address.latitude, lng: address.longitude })
    } else if (addressStr) {
      const geocodeAddress = () => {
        if (!core) return

        const geocoder = new google.maps.Geocoder()

        geocoder.geocode({ address: addressStr }, (results, status) => {
          if (status === "OK" && results && results[0]) {
            const geometry = results[0]?.geometry
            const lat = geometry.location.lat()
            const lng = geometry.location.lng()
            setPosition({ lat, lng })
          } else {
            // console.error("Geocode failed:", status)
          }
        })
      }
      geocodeAddress()
    }
  }, [core, addressStr, address?.latitude, address?.longitude])

  return !position ? null : (
    <StyledMapContainer locale={locale} newStyle={newStyle}>
      <Map
        defaultZoom={12}
        mapId={MAPID}
        defaultCenter={position}
        disableDefaultUI={true}
        zoomControl
        zoomControlOptions={{ position: 10 }}
      >
        <AdvancedMarker position={position}>
          <Pin
            // background="grey"
            // glyphColor={"purple"}
            borderColor={"green"}
          />
        </AdvancedMarker>
      </Map>
    </StyledMapContainer>
  )
}

function MiniMap({ address, locale, newStyle, addressStr }: Props) {
  return (
    <APIProvider apiKey={APIKEY} language={locale === "he" ? "iw" : "en"}>
      <MapContainer address={address} locale={locale} newStyle={newStyle} addressStr={addressStr} />
    </APIProvider>
  )
}

export default MiniMap
